'use strict'

$id = $('body').attr('id')
$class = $('body').attr('class')

# fixElement = $('.box1 .pic1')
# endElement = $('.box2')
# baseFixPoint = fixElement.offset().top
# endPoint = endElement.offset().top - fixElement.outerHeight(true) - $('#gnavi').outerHeight(true)
# fixClass = 'is-fixed'
#
# $(window).on('scroll',
#   ()->
#     fixFunction()
# )
#
# fixFunction = ()->
#   winScroll = $(window).scrollTop()
#
#   if winScroll > baseFixPoint - $(window).height()
#     $('.box1 .pic1__img').css({
#       'transform': 'translate3d(0px, 0px, 0px)' + 'scale(' + (2 - (winScroll / 2000)) + ', ' + (2 - (winScroll / 2000)) + ')'
#     })
#   else
#     $('.box1 .pic1__img').css({
#       'transform': 'scale(1, 1)'
#     })
#
#   if window.matchMedia('(max-width:750px)').matches
#     if winScroll >= baseFixPoint - $('.l-header').outerHeight(true)
#       fixElement.css({
#         'position': 'fixed'
#         'top': $('.l-header').outerHeight(true)
#       })
#
#       if winScroll >= endPoint
#         fixElement.css({
#           'position': 'absolute',
#           'top': 'auto',
#           'bottom': 0
#         })
#     else
#       fixElement.removeClass(fixClass)
#
#       fixElement.css({
#         'position': '',
#         'top': ''
#       })
#   else
#     if winScroll >= baseFixPoint - $('#gnavi').outerHeight(true)
#       fixElement.css({
#         'position': 'fixed'
#         'top': $('#gnavi').outerHeight(true)
#       })
#
#       if winScroll >= endPoint
#         fixElement.css({
#           'position': 'absolute',
#           'top': 'auto',
#           'bottom': 0
#         })
#     else
#       fixElement.removeClass(fixClass)
#
#       fixElement.css({
#         'position': '',
#         'top': ''
#       })

swiper = new Swiper('.swiper-container', {
  loop: true,
  speed: 600,
  autoplay: {
    delay: 6000,
    stopOnLastSlide: true,
    disableOnInteraction: true,
    reverseDirection: false
  },
  pagination: {
    el: '.swiper-pagination'
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
})

popup = $('.fixed-popup')
popupCloseButton = $('.fixed-popup__close')

popupCloseButton.on('click',
  ()->
    popup.addClass('is-hidden')
)

$(window).on('scroll',
  ()->
    if window.matchMedia('(max-width:750px)').matches
      if popup.hasClass('is-hidden')
      else
        if $(window).scrollTop() >= 200
          popup.addClass('is-active')
        else
          popup.removeClass('is-active')
)
